






import sizeable from '../../mixins/sizeable/sizeable';
import interactable from '../../mixins/interactable/interactable';
import colorable from '../../mixins/colorable/colorable';
import loadable from '../../mixins/loadable/loadable';
import mixins from '../../mixins';

export default mixins(sizeable, interactable, colorable, loadable).extend({
  mixins: [sizeable, interactable, colorable, loadable],
  props: {
    tag: { default: 'ul', type: String },
  },
  computed: {
    classList(): Record<string, boolean> {
      return {
        'p-list': true,
        dense: this.dense,
        spacious: this.spacious,
      };
    },
  },
});
